<template>
    <div v-if="getPermission.settings.view || getPermission.masterdata.view || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit"> 
    <!--
    <driver-form ref="DriverFormCreate" 
      mode="CREATE"/>
    -->
    <driver-form ref="DriverFormCreate"
      mode="CREATE"/>
    <driver-form ref="DriverFormUpdate"
      mode="UPDATE"/>  
    <driver-form ref="DriverFormInboundCreate"
      mode="INBOUNDCREATE"/>
    <driver-form ref="DriverFormInboundUpdate"
      mode="INBOUNDUPDATE"/>  
    <driver-form ref="DriverFormShowLicExp"
      mode="LICEXPHIST"/>
      
    <f-s-i-driver-form ref="FSIDriverFormCreate"
      mode="CREATE" :onfsicreate="updateFSIItem" />   
    <f-s-i-driver-form ref="FSIDriverFormUpdate"
      mode="UPDATE" :onfsicreate="updateFSIItem" />   

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
                <md-field>
                  <label id="label_firstName">First Name</label>
                  <md-input id="firstName" ref="firstName" v-model="searchRequest.firstName"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
             <div class = "inputBox">
                <md-field>
                  <label id="label_lastName">Last Name</label>
                  <md-input id="lastName" ref="lastName" v-model="searchRequest.lastName"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
             <div class = "inputBox">
                <md-field>
                  <label id="label_driverMobile">Driver Mobile</label>
                  <md-input id="driverMobile" ref="driverMobile" v-model="searchRequest.driverMobile"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <md-field>
                  <label id="label_tractorNum">Tractor#</label>
                  <md-input id="tractorNum" ref="tractorNum" v-model="searchRequest.tractorNum"/>
                </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
                <md-field>
                  <label id="label_trailerNum">Trailer#</label>
                  <md-input id="trailNum" ref="trailerNum" v-model="searchRequest.trailerNum"/>
                </md-field>
            </div>
          </div>


          <div v-if="getPermission.ccic.edit || getPermission.masterdata.edit || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/fsi/searchDriverData', '/api/w/fsi/updateDriverData']">
              <callingApiCenter path=" /api/w/fsi/searchDriverData" :not-display-error="true">
                  <md-button class="md-raised custButton " @click="doNew" ><span class="icons-center material-icons">create</span>New</md-button>
                  <md-button id = "searchTag"  @click="doSearch" class=" custButton btn-search-master-form-driver md-primary md-raised">Search</md-button>
                  <md-button class="md-raised custButton" @click="doClear">Clear</md-button>
                  <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"
                    />
                  <md-button class="md-raised custButton" @click="doDownloadExcel" :disabled="allowDownload">Download</md-button>                    
            <md-checkbox v-model="showOnlyActive">
              <label>Show Only Active Drivers</label>
            </md-checkbox>
        
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">

              <div class="table-header" v-if="getPermission.settings.edit || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>
                  <th class="header-cell w2"></th>
                    <th class="header-cell center w7" 
                        v-on:click="sortFunction('firstName')"
                    >First Name</th>
                    <th class="header-cell center w7" 
                        v-on:click="sortFunction('lastName')"
                    >Last Name</th>
                    <th class="header-cell center w10" 
                        v-on:click="sortFunction('driverMobile')"
                    >Driver Mobile</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('tractorNum')"
                    >Tractor#</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('trailerNum')"
                    >Trailer#</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('lastUseOn')"
                    >Last Use On</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('createdBy')"
                    >Created</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('createdAt')"
                    >Created Date</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('updatedBy')"
                    >Update</th>
                    <th class="header-cell center w5" 
                        v-on:click="sortFunction('updatedAt')"
                    >Update Date</th>
                    <th class="header-cell center w5" >Active</th>
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll" v-if="getPermission.settings.edit || getPermission.fsiMgt.edit || getPermission.fsiMgtWithRemark.edit">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vuekey" v-for="item in pageItems">
                     <td class="body-cell w2 ">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                    </td>
                    <td class="body-cell excelBox w7">{{item.firstName}}</td>
                    <td class="body-cell excelBox w7">{{item.lastName}}</td>
                    <td class="body-cell excelBox w10">{{item.driverMobile}}</td>
                    <td class="body-cell excelBox w5">{{item.tractorNum}}</td>
                    <td class="body-cell excelBox w5">{{item.trailerNum}}</td>
                    <td class="body-cell excelBox w5">{{item.lastUseOn | date}}</td>
                    <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedAt | date}}</td>
                    <td class="body-cell excelBox w5">
                       <md-checkbox v-model="item.active" disabled></md-checkbox>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="table-header" v-if="getPermission.masterdata.edit">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>
                  <th class="header-cell w2"></th>
                  <!--
                    <th class="header-cell center w5" >Drive No.</th>
                  -->  
                    <th class="header-cell center w5" >Short ID</th>
                  <!--  
                    <th class="header-cell center w5" >Default Sales Office</th>
                  -->  
                    <th class="header-cell center w5" >Default Plate (Truck No)</th>
                   <!-- 
                    <th class="header-cell center w5" >Address-City</th>
                    <th class="header-cell center w5" >Address-State</th>
                    <th class="header-cell center w5" >Address-Post Code</th>
                    <th class="header-cell center w5" >Telephone</th>
                   --> 
                    <th class="header-cell center w5" >Mobile</th>
                   <!-- 
                    <th class="header-cell center w5" >Hiring Start Date</th>
                    <th class="header-cell center w5" >Termination Date</th>
                    <th class="header-cell center w5" >License</th>
                    <th class="header-cell center w5" >License Exp Date</th>
                    <th class="header-cell center w5" >DMV Record Type</th>
                    <th class="header-cell center w5" >DMV Notification mail out date</th>
                    <th class="header-cell center w5" >MED Exp. Date</th>
                    <th class="header-cell center w5" >Drug Test Exp. Date</th>
                    <th class="header-cell center w5" >Insurance Exp. Date</th>
                   --> 
                    <th class="header-cell center w5" >Trailer Num</th>
                   <!-- 
                    <th class="header-cell center w5" >Created</th>
                    <th class="header-cell center w5" >Created Date</th>
                    <th class="header-cell center w5" >Update</th>
                    <th class="header-cell center w5" >Update Date</th>
                   --> 
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll" v-if="getPermission.masterdata.edit">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vuekey" v-for="item in pageItems">
                     <td class="body-cell w2 ">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                    </td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.driverId}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.shortId}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.defaultSalesOffice}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.defaultPlateNum}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.driverCity}}</td>
                    <td class="body-cell excelBox w5">{{item.driverState}}</td>
                    <td class="body-cell excelBox w5">{{item.postal}}</td>
                    <td class="body-cell excelBox w5">{{item.driverTel}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.driverMobile}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.hiringStartDate }}</td>
                    <td class="body-cell excelBox w5">{{item.terminationDate}}</td>
                    <td class="body-cell excelBox w5">{{item.licenseNum}}</td>
                    <td class="body-cell excelBox w5" @click="showLicExpHist(item)">{{item.licenseExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvRecType}}</td>
                    <td class="body-cell excelBox w5">{{item.dmvNotifMailOutDate}}</td>
                    <td class="body-cell excelBox w5">{{item.medExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.drugTestExpDate}}</td>
                    <td class="body-cell excelBox w5">{{item.insExpDate}}</td>
                    -->
                    <td class="body-cell excelBox w5">{{item.trailernum}}</td>
                    <!--
                    <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                    -->
                  </tr>
                  </tbody>
                </table>
              </div>


            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>
</template>


<style scoped>


.excelBox {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.8rem;
   
}

.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
   
}

.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}
</style>

<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  import api from "../api";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import DriverForm from '../components/DriverForm.vue';
  import FSIDriverForm from '../components/FSIDriverForm.vue';
  import sort from "fast-sort";


   const getInitSearch = () => ({
           office: "FSI",
           firstName: null,
           lastName: null,
           driverMobile: null,
           tractorNum: null,
           trailerNum: null,
           currentDrivers: false,
           onlyActive: false,
   });

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      active: false,
      items: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      sortStatus: true,
      filter:"",
      showOnlyActive: false,
      allowDownload: false,
    }),


    components: {
      callingApiCenter,
      //DriverForm,
      FSIDriverForm,
    },

    watch: {
      getFSIDriverMaster(val) {
        this.updateItems(val);
      },
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getFSIDriverMaster',
      ]),

      filteredRows(){
        // return this.items.filter(row => {
        //   const term = this.filter.toUpperCase();
        //   return this.includeNull(null).includes(term)
        // })
        var p_items = this.items.filter(row => {
            const term = this.filter.toUpperCase();
            return this.includeNull(null).includes(term);
        });
        if (this.showOnlyActive)
        {
            return p_items.filter((it) => it.active).sort();
        } else {
           return p_items.sort();
        }
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },
    },

    async mounted() {
        const cachedSearchRequest = this.$store.state.fsiDriverMaster.searchRequest;
        this.searchRequest.office = "FSI";
        //this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        //this.searchRequest.driverOffice = "FSI";
        this.$el.querySelector('#searchTag').click();
        console.log("this.getFSIDriverMaster:" + this.getFSIDriverMaster);
        this.updateItems(this.getFSIDriverMaster);
    },

     methods: {
        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
          this.active = !this.active;
        },

        updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },

        handleDriverStatusChanged(id) {
            this.searchRequest.driverStatus = id;
        },

        handleDriverTypeChanged(id) {
            this.searchRequest.driverType = id;
        },

        handleDefaultSalesOfficeChanged(id) {
            this.searchRequest.defaultSalesOffice = id;
        },

        doSearch() {
            //this.$store.dispatch('gstDriverMaster', this.searchRequest);
            //this.searchRequest.driverStatus;
            console.log("Driver master search driver name: " + this.searchRequest.shortId);
            console.log("search data: " + this.searchRequest.trailernum + " " + this.searchRequest.driverMobile)
            //this.searchRequest.defaultSalesOffice = "LGB"
            this.$store.dispatch('fsiDriverMaster', this.searchRequest)
            .then(() => {
               this.checkAllowDownload();
            });
            //.filter(
            //   it => 
            //)
            //  .filter(it => (this.searchRequest.driverId === "100002"))
              ;
        },


        doClear(){
            _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
              .each((it) => {
                  console.log(it);
                  it.click();
              });
              this.$nextTick(() => {
              this.searchRequest = getInitSearch();
            });

        },

        checkAllowDownload()
        {
             console.log(`disable download: ${JSON.stringify(this.items)}`);
             if (this.items != null && this.items.length > 0)
             {
                 this.allowDownload = false;
             } else {
                 this.allowDownload = true;
             }
        },

        doDownloadExcel(){
            const request = toGenerateExcelRequest(
                              this.$el.querySelector('.data-table-container .inner-container'),
                              'FSI_Driver_List.xls',
                              1,
            );
            request.heads = _(request.heads).take(12);
            request.rows = _(this.items)
            .map(item => [
              '',
              item.firstName,
              item.lastName,
              item.driverMobile,
              item.tractorNum,
              item.trailerNum,
              item.lastUseOn,
              item.createdBy,
              dateFormat.date(item.createdAt),
              item.updatedBy,
              dateFormat.date(item.updatedAt),
              (item.active)? 'Yes' : 'No'
            ]);
            this.$store.dispatch('generateExcel', request)
              .then((res) => {
                window.open(res.url, 'blank');
              });
            this.isdisableSend = true; 
            this.isdisablephoto = true; 
        },

        handleScroll(e) {
            $(this.$el.querySelector('.table-header'))
            .offset({
                left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left),
            });
        },

        doNew() {
        var maxId = this.getMaxId(); 
        console.log('maxid:' + maxId);
        this.$refs.FSIDriverFormCreate.openDialog(maxId);
        // if (this.getPermission.settings.view)
        //     this.$refs.DriverFormCreate.openDialog(maxId);
        // else
        //      this.$refs.DriverFormInboundCreate.openDialog(maxId);
        },

        toggleUpdate(item) {
          console.log("toggleUpdate:" + item.driverId);
          console.log("item selected value: " + item.selected);
        //console.log("item vuekey: " + item.vuekey);
        //if (item.selected)
        //if (this.getPermission.settings.view)
        //   this.$refs.DriverFormUpdate.openDialog(item);
        //else   
        //   this.$refs.DriverFormInboundUpdate.openDialog(item);
          this.$refs.FSIDriverFormUpdate.openDialog(item);
        },

        showLicExpHist(item) {
          console.log("show lic history");
          this.$refs.DriverFormShowLicExp.openDialog(item);
        },

        getMaxId() {
          return '100008';
        },

        includeNull(field){
                return field==null ? '' : field;
            },
        getValidationClass(fieldName) {
           const field = _(this.$v)
            .lookup(fieldName);
           if (field) {
              return {
                 'md-invalid': field.$invalid && field.$dirty,
              };
           }
           return {};
        },
        updateFSIItem(firstname, lastname, mobile, trailernum, tractornum) {
          console.log("firstname: " + firstname + " lastname: " + lastname + " mobile: " + mobile + " trailernum: " + trailernum + " tractornum: " + tractornum);
        },
        sortFunction(sortFiled) {
          const sorted = sort(this.items).asc(sortFiled);
          this.sortStatus = !this.sortStatus;
          if (this.sortStatus) {
             this.items = sorted;
          } else {
             this.items = sorted.reverse();
          }
        },       
        
      },


    }
</script>